import { ANGRY_GHOST, SATISFIED_GHOST } from '../../TwoD/Common/CardUtilities';

export default function artificialPlaceGhost(gamePlayerController, aiPackage) {
    let attackingGhosts = gamePlayerController.gamePlayerData.attacking_ghosts;
    if (attackingGhosts.length === 0) {
        aiPackage.success = fail;
        aiPackage.addToMessage(`No Ghosts to place.`);
        return aiPackage;
    }

    let dockWeights = [0, 2, 2, 2];
    gamePlayerController.gamePlayerData.docks.map((cardId, dockIndex) => {
        if (cardId === ANGRY_GHOST) {
            dockWeights[dockIndex] -= 10;
        } else if (cardId === null) {
            dockWeights[dockIndex] += 3;
        } else if (cardId === SATISFIED_GHOST) {
            dockWeights[dockIndex] += 2;
        } else {
            // will displace guest.
            dockWeights[dockIndex] += 1;
        }
    });
    let heaviest = Math.max(...dockWeights);
    let dockIndex = 3 - dockWeights.slice().reverse().indexOf(heaviest);
    let question = `Which Dock is best for a Ghost? `;
    let answer = dockIndex;
    let reason = 'From 3 to 0, Weight each dock, 3=Empty, 2=Ghosted, 1=Guest.'
    aiPackage.addProvenance(question, answer, reason);
    aiPackage.success = true;
    aiPackage.addToMessage(`Place Ghost in Dock ${dockIndex}`);
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.placeGhost(dockIndex);
    }
}
